import React, { FC } from 'react';

import Rive, { Fit, Layout } from '@rive-app/react-canvas';

import { useThemeMode } from '~/contexts/ThemeModeContext';

import styles from './styles.module.scss';
import { getLoaderAnimationSrc } from '../Loader/utils';

const FULLSCREEN_LOADER_LAYOUT = new Layout({
  fit: Fit.Cover,
});

const FullscreenPreloader: FC = () => {
  const { themeMode } = useThemeMode();
  const animationSrc = getLoaderAnimationSrc(themeMode);

  return (
    <div className={styles.container}>
      <div className={styles.animation}>
        <Rive
          layout={FULLSCREEN_LOADER_LAYOUT}
          shouldResizeCanvasToContainer
          src={animationSrc}
        />
      </div>
    </div>
  );
};

export default FullscreenPreloader;
